export const TMAIL_V3_DASHBOARD = '/dashboard/tmail/v3'
export const TMAIL_V3_APPLICATION = '/dashboard/tmail/v3/application'
export const TMAIL_V3_APPLICATION_SETTING = '/dashboard/tmail/v3/application/setting/:id'
export const TMAIL_V3_ADD_APPLICATION = '/dashboard/tmail/v3/application/add'
export const TMAIL_V3_DOMAIN = '/dashboard/tmail/v3/domain'
export const TMAIL_V3_DOMAIN_LIST = '/dashboard/tmail/v3/domain/list'
export const TMAIL_V3_MEMBERS = '/dashboard/tmail/v3/members'
export const TMAIL_V3_ADD_MEMBER = '/dashboard/tmail/v3/members/add'
export const TMAIL_V3_ACCOUNT_DETAILS = '/dashboard/tmail/v3/account-detail'